// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark .itemrate{background-color:#474747;border-color:#525252}html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark .itemrate-heart svg{fill:#cb4526}html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark .itemrate-heart.mod-empty svg{opacity:.15}\n", ""]);
// Exports
module.exports = exports;
